import { GSE_PREFERENCE } from "./product-constant";
import { IdNameObjectType } from "../../state/models/global-configuration-state.model";
import { FormGroup } from "@angular/forms";
import { InsideMapsTrakingConfigurationInfo } from "./product.model";

const inspectionEnabled = function(control, jsonModelService: any) {
	return jsonModelService.FindValue('enabled');
};

export const INSPECTION_FORM_CONFIG = {
	inspection: {
		enabled: {
			path: 'inspection.enabled',
			DataType: 'Boolean',
			DisplayText: `Enable Inspection(Creates an Inspection when the acuity order is'Accepted by the Vendor')`,
			Name: 'enabled',
			customClass: 'product-form-switch ms-5 mb-4 mt-4',
			required: false,
			Visible: function(control, jsonModelService: any) {
				const acuityEnabled = jsonModelService.FindRootValue('acuity.enabled');
				const enableHandheld = jsonModelService.FindRootValue('enableHandheld');
				return (acuityEnabled && !enableHandheld) || false;
			},
			UIEvents: {
				onChange: function($event: any, model: any, formGroup: FormGroup, extraData: any) {
					const enableHandheld = formGroup.get('enableHandheld').value;

					if (enableHandheld) {
						formGroup.get('enableHandheld').setValue(false);
					}
					formGroup.get('insideMaps.insideMapsId').setValue(null);
					formGroup.get('insideMaps.insideMapsName')?.setValue(null);
					formGroup.get('insideMaps.insideMapsFee').setValue(null);
					
					formGroup.get('inspection.softwareCollector').setValue(null);
					formGroup.get('inspection.gsePreference').setValue(null)
					formGroup.get('inspection.schema').setValue(null);
					formGroup.get('inspection').updateValueAndValidity();
					formGroup.updateValueAndValidity();
				}
			}
		},
		injectImagesIntoForm: {
			path: 'inspection.injectImagesIntoForm',
			DataType: 'Boolean',
			DisplayText: `Inject Images into Formset`,
			Name: 'injectImagesIntoForm',
			customClass: 'product-form-switch ms-5 mb-4 mt-4',
			required: false,
			Visible: inspectionEnabled
		},
		keepInspection: {
			path: 'inspection.keepInspection',
			DataType: 'Boolean',
			DisplayText: `Keep Inspection(Avoid create a new inspection each time the order is 'Accepted by the Vendor')`,
			Name: 'keepInspection',
			customClass: 'product-form-switch ms-5 mb-4 mt-4',
			required: false,
			Visible: inspectionEnabled
		},
		schema: {
			DataType: 'Selector',
			path: 'inspection.schema',
			UIControl: 'Dropdown',
			DisplayText: 'Schema',
			label: 'Schema',
			Name: 'schema',
			customClass: 'product-form-dropdown',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: any) {
				return jsonModelService.IsEmpty() && (jsonModelService.FindValue('enabled') || jsonModelService.FindRootValue('enableHandheld'));
			},
			Visible: function(control, jsonModelService: any) {
				return jsonModelService.FindValue('enabled') || jsonModelService.FindRootValue('enableHandheld');
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;

					if ([ 'InspectionReport:4.0' ].indexOf(value) === -1) {
						//formGroup.get('inspection.useUPD')?.setValue(false);
					}
				},
			}
		},
		gsePreference: {
			DataType: 'Selector',
			path: 'inspection.gsePreference',
			UIControl: 'Dropdown',
			DisplayText: 'GSE Preference',
			label: 'GSE Preference',
			Name: 'gsePreference',
			customClass: 'product-form-dropdown',
			required: false,
			options: GSE_PREFERENCE.map((item: IdNameObjectType) => {
				return {
					label: item.name,
					value: item.id,
				};
			}),
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: any) {
				return jsonModelService.IsEmpty() && jsonModelService.FindValue('enabled');
			},
			Visible: function(control, jsonModelService: any) {
				return jsonModelService.FindValue('enabled');
			}
		},
		gseFungible: {
			path: 'inspection.gseFungible',
			DataType: 'Boolean',
			DisplayText: `Enable GSE Fungibility`,
			Name: 'gseFungible',
			customClass: 'product-form-switch ms-5 mt-4',
			required: false,
			Visible: inspectionEnabled,
		},
		useUPD: {
			path: 'inspection.useUPD',
			DataType: 'Boolean',
			DisplayText: `Use UPD`,
			Name: 'useUPD',
			customClass: 'product-form-switch mt-4',
			required: false,
			Visible: function(control, modelFormService: any) {
				const inspectionSchema = modelFormService.FindValue('schema');
				const inspectionEnabled = modelFormService.FindValue('enabled');
				const acuity3DProduct = modelFormService.FindRootValue('acuity.is3dProduct')
				return inspectionEnabled && acuity3DProduct && ([ 'InspectionReport:4.0' ].indexOf(inspectionSchema) >= 0)
			},
		},
		disableFREDDIESubmition: {
			path: 'inspection.disableFREDDIESubmition',
			DataType: 'Boolean',
			DisplayText: `Disable FREDDIE Submission`,
			Name: 'disableFREDDIESubmition',
			customClass: 'product-form-switch ms-5 mb-4 mt-4',
			required: false,
			Visible: inspectionEnabled,
		},
		disableFNMASubmition: {
			path: 'inspection.disableFNMASubmition',
			DataType: 'Boolean',
			DisplayText: `Disable FNMA Submission`,
			Name: 'disableFNMASubmition',
			customClass: 'product-form-switch mb-4 mt-4',
			required: false,
			Visible: inspectionEnabled,
		},
		softwareCollector: {
			DataType: 'Selector',
			path: 'inspection.softwareCollector',
			UIControl: 'Dropdown',
			DisplayText: 'Software Collector',
			label: 'Software Collector',
			Name: 'softwareCollector',
			customClass: 'product-form-dropdown',
			options: [],
			required: false,
			Visible: function(control, jsonModelService: any) {
				return jsonModelService.FindValue('enabled') || jsonModelService.FindRootValue('enableHandheld');
			},
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;

					formGroup.get('insideMaps')?.setValue(new InsideMapsTrakingConfigurationInfo());

					if (value === 'InsideMaps') {
						formGroup.get('insideMaps.enabled')?.setValue(true);
					} else {
						formGroup.get('insideMaps.enabled')?.setValue(false);
					}
				},
			}
		},
	}
};
